import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const AllExperts = dynamic(() => import('./AllExperts').then((m) => ({ default: m.AllExperts })));

const allExpertsConfig = {
  name: 'All Experts',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      required: true,
    },
    {
      name: 'body',
      type: 'richText',
      required: true,
    },
  ],
};

Builder.registerComponent(AllExperts, allExpertsConfig);
